/** Early-booking market pattern: customers booking early into a falling market. */
import type { EarlyBookingEntry, PatternPayload } from "@/types/feed";

import { customerBookingsHref } from "../../feedLinks";
import { compareScale } from "../formatInsight";
import { explainerFor } from "../insightCopy";
import { ChangeRow, EntitySection, InsightShell } from "../primitives";

export function EarlyBookingView({ payload }: { payload: PatternPayload }) {
  const customers = payload.top_customers as EarlyBookingEntry[] | undefined;
  const declineMax = compareScale((customers ?? []).map((row) => row.decline_pct));
  return (
    <InsightShell explainer={explainerFor(payload as unknown as Record<string, unknown>)}>
      {customers && customers.length > 0 && (
        <EntitySection title="Customers">
          {customers.map((c) => (
            <ChangeRow
              key={c.consignee}
              name={c.consignee}
              href={customerBookingsHref(c.consignee)}
              party
              primary={`${Math.round(c.decline_pct)}% of ${c.shipment_count}`}
              subtitle={`~${Math.round(c.avg_days_early)}d early on average`}
              bar={{ type: "share", value: c.decline_pct, max: declineMax }}
            />
          ))}
        </EntitySection>
      )}
    </InsightShell>
  );
}
